import { useDeviceSelectors } from 'react-device-detect';

import Chrome from 'icons/browsers/chrome.svg';
import Safari from 'icons/browsers/safari.svg';
import FF from 'icons/browsers/firefox.svg';
import Edge from 'icons/browsers/edge.svg';

type SupportDetails = {
  browserName: string;
  browserVersion: string;
  downloadUrl: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
};

export default function useGetBrowserSupportDetails(): SupportDetails | null {
  const [
    {
      browserName,
      browserVersion,
      isChrome,
      isSafari,
      isFirefox,
      isLegacyEdge,
      isWindows
    }
  ] = useDeviceSelectors(window.navigator.userAgent);

  const commonProperties = {
    browserName,
    browserVersion
  };

  if (isChrome && browserVersion < 58) {
    return {
      ...commonProperties,
      Icon: Chrome,
      downloadUrl: 'https://www.google.com/chrome'
    };
  }

  if (isSafari && browserVersion < 13) {
    return {
      ...commonProperties,
      Icon: Safari,
      downloadUrl: 'https://support.apple.com/HT204416'
    };
  }

  if (isFirefox && browserVersion < 95) {
    return {
      ...commonProperties,
      Icon: FF,
      downloadUrl: 'https://www.mozilla.org/firefox/new'
    };
  }

  /* Microsoft Edge Legacy was only available on Windows 10:
   * https://learn.microsoft.com/en-us/microsoft-edge/web-platform/user-agent-guidance#microsoft-edge-legacy */
  if (isWindows && isLegacyEdge) {
    return {
      ...commonProperties,
      Icon: Edge,
      downloadUrl: 'https://www.microsoft.com/en-us/edge'
    };
  }

  return null;
}
